import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        progress: '='
    },
    template: `
            <div class="col00">
                <div class="person01">
                    <div class="txt">
                        <div class="heading01 type01">
                            <h1>{{ 'validations.Validation' | translate }}
                                <small>{{ vm.COURSE_TRAINING_STATUS_TYPE_ENUM.LABELS[vm.progress.status] }}</small>
                            </h1>
                            <ul class="actions01">
                                <li>
                                    <button class="btn ico-print" href="#" ng-click="vm.print();">{{ 'general.Print' | translate }}</button>
                                </li>
                                <li>
                                    <a ng-click="vm.setAsNotPassed()" ng-if="vm.progress.status===vm.COURSE_TRAINING_STATUS_TYPE_ENUM.KEYS.IN_ASSESSMENT"
                                        class="btn negative">{{ 'validations.Mark as not passed' | translate }}
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <dl>
                            <dt>{{ 'courses.Employee' | translate }}</dt>
                            <dd>{{ vm.progress.user.displayName }}</dd>
                            <dt>{{ 'course.Course' | translate }}</dt>
                            <dd>{{ vm.progress.occurrence.course.activeI18n.name }}</dd>
                            <dt>{{ 'occurrence.Training' | translate }}</dt>
                            <dd>{{ vm.progress.occurrenceTraining.training.activeI18n.name }}</dd>
                            <dt>{{ 'validations.Date taken' | translate }}</dt>
                            <dd>{{ vm.formatDate(vm.progress.formSubmission.finishTime) }}</dd>
                            <dt>{{ 'validations.Points obtained' | translate }}</dt>
                            <dd>{{ vm.getCollectedPoints(vm.progress) }}</dd>
                        </dl>
                    </div>
                </div>
                <div ng-if="!vm.progress.formSubmission.formSubmissionAnswers.length" class="alert alert-notify">
                    {{ 'validations.Results not available' | translate }}
                </div>
                <div ng-if="vm.needsValidationCount() > 0" class="well color02">
                    <div class="heading01">
                        <h2>{{ 'questionAnswer.Needs manual assesment' | translate }}</h2>
                    </div>
                    <div class="tablewrapper">
                        <table ui-tree class="data01" datatable="ng" dt-options="vm.DATATABLES">
                            <thead>
                                <tr>
                                    <th class="sorting_disabled" rowspan="1" colspan="1">{{ 'forms.Question' | translate }}</th>
                                    <th class="sorting_disabled" rowspan="1" colspan="1">{{ 'forms.Category' | translate }}</th>
                                    <th class="sorting_disabled" rowspan="1" colspan="1">{{ 'course.target.Compulsory' | translate }}</th>
                                    <th class="sorting_disabled" rowspan="1" colspan="1">&nbsp;</th>
                                    <th class="none dt-hide"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ng-if="vm.isAnswerNeedsValidation(fsAnswer)" ng-repeat="(key, fsAnswer) in vm.progress.formSubmission.formSubmissionAnswers">
                                    <td class="collapsable" tabindex="0">{{ fsAnswer.question.nameWithoutHtml }}</td>
                                    <td>{{ fsAnswer.question.category.activeI18n.name }}</td>
                                    <td ng-if="fsAnswer.isQuestionRequired"><span class="ico-check positive"></span></td>
                                    <td ng-if="!fsAnswer.isQuestionRequired"><span class="ico-cross negative"></span></td>
                                    <td class="actions"><a class="btn edit" ng-click="vm.assess(fsAnswer, key)">{{ 'validations.Assess' | translate }}</a></td>
                                    <td>
                                        <table ng-if="fsAnswer.question.questionAnswers.length" class="data01">
                                            <thead>
                                                <tr>
                                                    <th class="ng-binding">{{ 'question.Answer' | translate }}</th>
                                                    <th ng-if="vm.isPartialPoints(fsAnswer)" class="ng-binding">{{ 'questions.Points' | translate }}</th>
                                                    <th class="ng-binding">{{ 'questions.Correct' | translate }}</th>
                                                    <th class="ng-binding">{{ 'questions.Answer selected' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr ng-repeat="answer in fsAnswer.question.questionAnswers">
                                                    <td>{{ answer.text }}</td>
                                                    <td ng-if="vm.isPartialPoints(fsAnswer)">{{ answer.points ? answer.points : 0 }}</td>
                                                    <td>
                                                        <span ng-if="answer.isCorrectAnswer" class="ico-check positive"></span>
                                                        <span ng-if="!answer.isCorrectAnswer" class="ico-cross negative"></span>
                                                    </td>
                                                    <td>
                                                        <span ng-if="vm.isAnwserSelected(fsAnswer.question.id, answer)" class="ico-check positive"></span>
                                                        <span ng-if="!vm.isAnwserSelected(fsAnswer.question.id, answer)" class="ico-cross negative"></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table ng-if="fsAnswer.question.questionAnswers.length === 0 && fsAnswer.answerText" class="data01">
                                            <thead>
                                                <tr>
                                                    <th class="ng-binding">{{ 'question.Answer' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <td>{{ fsAnswer.answerText }}</td>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div ng-if="vm.needsValidationCount() !== vm.progress.formSubmission.formSubmissionAnswers.length" class="well color03">
                    <div class="heading01">
                        <h2>{{ 'validations.Test questions' | translate }}</h2>
                    </div>
                    <div class="tablewrapper">
                        <table ui-tree class="data01" datatable="ng" dt-options="vm.DATATABLES">
                            <thead>
                                <tr>
                                    <th>{{ 'forms.Question' | translate }}</th>
                                    <th>{{ 'forms.Category' | translate }}</th>
                                    <th>{{ 'course.target.Compulsory' | translate }}</th>
                                    <th>{{ 'validations.Points obtained' | translate }}</th>
                                    <th class="w1p">&nbsp;</th>
                                    <th class="none dt-hide"></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr ng-if="!vm.isAnswerNeedsValidation(fsAnswer)" ng-repeat="(key, fsAnswer) in vm.mappedFsAnswers">
                                    <td class="collapsable" tabindex="0">{{ fsAnswer.question.nameWithoutHtml }}</td>
                                    <td>{{ fsAnswer.question.category.activeI18n.name }}</td>
                                    <td ng-if="fsAnswer.isQuestionRequired"><span class="ico-check positive"></span></td>
                                    <td ng-if="!fsAnswer.isQuestionRequired"><span class="ico-cross negative"></span></td>
                                    <td>{{ vm.getPointsObtained(fsAnswer) }}</td>
                                    <td class="actions"><a class="btn edit"
                                        ng-if="fsAnswer.question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT || fsAnswer.question.type === vm.QUESTIONS_TYPE_ENUM.KEYS.FREE_TEXT_PREDEFINED"
                                        ng-click="vm.assess(fsAnswer, key)">{{ 'validations.View answer' | translate }}</a></td>
                                    <td>
                                        <table ng-if="fsAnswer.question.questionAnswers.length" class="data01">
                                            <thead>
                                                <tr>
                                                    <th class="ng-binding">{{ 'question.Answer' | translate }}</th>
                                                    <th ng-if="vm.isPartialPoints(fsAnswer)" class="ng-binding">{{ 'questions.Points' | translate }}</th>
                                                    <th class="ng-binding">{{ 'questions.Correct' | translate }}</th>
                                                    <th class="ng-binding">{{ 'questions.Answer selected' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr ng-repeat="answer in fsAnswer.question.questionAnswers">
                                                    <td>{{ answer.text }}</td>
                                                    <td ng-if="vm.isPartialPoints(fsAnswer)">{{ answer.points ? answer.points : 0 }}</td>
                                                    <td>
                                                        <span ng-if="answer.isCorrectAnswer" class="ico-check positive"></span>
                                                        <span ng-if="!answer.isCorrectAnswer" class="ico-cross negative"></span>
                                                    </td>
                                                    <td>
                                                        <span ng-if="vm.isAnwserSelected(fsAnswer.question.id, answer)" class="ico-check positive"></span>
                                                        <span ng-if="!vm.isAnwserSelected(fsAnswer.question.id, answer)" class="ico-cross negative"></span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <table ng-if="fsAnswer.question.questionAnswers.length === 0 && fsAnswer.answerText" class="data01">
                                            <thead>
                                                <tr>
                                                    <th class="ng-binding">{{ 'question.Answer' | translate }}</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <td>{{ fsAnswer.answerText }}</td>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <ul class="actions01">
                    <li> <a class="btn discrete" ui-sref="authorized.forms.validations.list()">{{ 'general.Back to list' | translate }}</a></li>
                </ul>
            </div>
    `
})
export default class {
    constructor (lodash, USER_STATUS_ENUM, ROLE_COMPANY_PRIVILEGE_ENUM, COMPANY_LANGUAGE_ENUM, TIMEZONE_ENUM,
                 PrivilegeService, MomentService, UserManagerService, TokenService, DATATABLES, ModalService,
                 TrainingProgressResource, $rootScope, COURSE_TRAINING_STATUS_TYPE_ENUM, CompanyResource,
                 QUESTIONS_TYPE_ENUM, FormFactory, $translate, $) {
        this.ModalService = ModalService;
        this.lodash = lodash;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
        this.ROLE_COMPANY_PRIVILEGE_ENUM = ROLE_COMPANY_PRIVILEGE_ENUM;
        this.COMPANY_LANGUAGE_ENUM = COMPANY_LANGUAGE_ENUM;
        this.TIMEZONE_ENUM = TIMEZONE_ENUM;
        this.DATATABLES = DATATABLES;
        this.PrivilegeService = PrivilegeService;
        this.MomentService = MomentService;
        this.canManageUsers = PrivilegeService.canManageUsers();
        this.canManageLicencePoints = PrivilegeService.canManageLicencePoints();
        this.UserManagerService = UserManagerService;
        this.TokenService = TokenService;
        this.TrainingProgressResource = TrainingProgressResource;
        this.COURSE_TRAINING_STATUS_TYPE_ENUM = COURSE_TRAINING_STATUS_TYPE_ENUM;
        this.CompanyResource = CompanyResource;
        this.QUESTIONS_TYPE_ENUM = QUESTIONS_TYPE_ENUM;
        this.FormFactory = FormFactory;
        this.$translate = $translate;
        this.$ = $;

        $rootScope.$on('reload:progress', () => {
            this.updateProgress();
        });

        this.mappedFsAnswers = this.getMappedFsAnswers(this.progress.formSubmission.formSubmissionAnswers);
    }

    print () {
        this.$('tr:not(.parent) .collapsable').click();
        window.print();
    }

    isPartialPoints (fsAnswer) {
        if (fsAnswer.question.type === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX) {
            if (!fsAnswer.question.isPartialPoints) {
                return false;
            }
        }
        return true;
    }

    getPointsObtained (answer) {
        if (answer.question.type === this.QUESTIONS_TYPE_ENUM.KEYS.CHECKBOX && !answer.question.isPartialPoints) {
            // if all answers are correct - return question max points, otherwise - 0 points.
            let isCorrect = true;

            this.lodash.forEach(answer.question.questionAnswers, questionAnswer => {
                if (questionAnswer.isCorrectAnswer && !this.isAnwserSelected(answer.question.id, questionAnswer)) {
                    isCorrect = false;
                }
                if (!questionAnswer.isCorrectAnswer && this.isAnwserSelected(answer.question.id, questionAnswer)) {
                    isCorrect = false;
                }
            });

            return isCorrect ? answer.question.points : 0;
        }

        let points = 0;

        this.lodash.forEach(this.progress.formSubmission.formSubmissionAnswers, fsAnswer => {
            if (fsAnswer.question.id === answer.question.id) {
                points += fsAnswer.points;
            }
        });

        if (points < 0) {
            points = 0;
        }

        return Math.round(points * 100000) / 100000;
    }

    getMappedFsAnswers (formSubmissionAnswers) {
        const results = [];
        this.lodash.forEach(formSubmissionAnswers, fsAnswer => {
            if (!results.find(item => item.question.id === fsAnswer.question.id)) {
                results.push(fsAnswer);
            }
        });
        return results;
    }

    getCollectedPoints (item) {
        if (!item.formSubmission) {
            return '- / -';
        }

        let totalPoints = (item.formSubmission.totalPoints || item.formSubmission.totalPoints === 0) ? item.formSubmission.totalPoints : '-';
        if (totalPoints < 0) {
            totalPoints = 0;
        }

        const maxScore = item.formSubmission.maxScore ? item.formSubmission.maxScore : '-';
        return `${totalPoints} / ${maxScore}`;
    }

    formatDate (time) {
        const timestamp = (Number(`${time}000`));
        return this.MomentService.convertToTimezone(new Date(timestamp), this.TokenService.getCompanyTimezone(), 'DD.MM.YYYY HH:mm');
    }

    isAnswerNeedsValidation (fsAnswer) {
        return fsAnswer.question && fsAnswer.question.isAssessmentNeeded && fsAnswer.points === null;
    }

    needsValidationCount () {
        let count = 0;
        this.lodash.forEach(this.progress.formSubmission.formSubmissionAnswers, fsAnswer => {
            if (this.isAnswerNeedsValidation(fsAnswer)) {
                count++;
            }
        });
        return count;
    }

    isAnwserSelected (questionId, answer) {
        let isAnswered = false;
        this.lodash.forEach(this.progress.formSubmission.formSubmissionAnswers, fsAnswer => {
            if (fsAnswer.question.id === questionId && fsAnswer.answer && fsAnswer.answer.id === answer.id) {
                isAnswered = true;
            }
        });

        return isAnswered;
    }

    assess (fsAnswer, index) {
        const { progress } = this;

        return this.ModalService.open({
            size: 'large',
            template: `
                <forms-validations-detail-assess
                    ok="vm.$uibModalInstance.close()"
                    cancel="vm.$uibModalInstance.dismiss()"
                    progress="vm.progress"
                    fs-answer="vm.fsAnswer"
                    index="vm.index"
                ></forms-validations-detail-assess>
            `,
            controller ($uibModalInstance) {
                this.$uibModalInstance = $uibModalInstance;
                this.fsAnswer = fsAnswer;
                this.progress = progress;
                this.index = index;
            }
        });
    }

    updateProgress () {
        this.TrainingProgressResource.get({
            id: this.progress.id,
            expand: 'user,occurrence.course.activeI18n,formSubmission.formSubmissionAnswers,occurrenceTraining.training.activeI18n,' +
            'formSubmission.formSubmissionAnswers.answer,formSubmission.formSubmissionAnswers.question.activeI18n,' +
            'formSubmission.formSubmissionAnswers.question.category.activeI18n,' +
            'formSubmission.formSubmissionAnswers.question.questionAnswers'
        }).$promise.then((progress) => {
            this.progress = progress;
            this.mappedFsAnswers = this.getMappedFsAnswers(this.progress.formSubmission.formSubmissionAnswers);
        });
    }

    setAsNotPassed () {
        const confirmMessage = this.$translate.instant('validations.Are you sure you want to mark the training as not passed?');
        this.ModalService.confirm(confirmMessage, 'medium')
        .then(() => {
            this.form = this.FormFactory.createFromResource(this.progress, {
                expand: 'user,occurrence.course.activeI18n,formSubmission.formSubmissionAnswers,occurrenceTraining.training.activeI18n,' +
                'formSubmission.formSubmissionAnswers.answer,formSubmission.formSubmissionAnswers.question.activeI18n,' +
                'formSubmission.formSubmissionAnswers.question.category.activeI18n,' +
                'formSubmission.formSubmissionAnswers.question.questionAnswers'
            });
            this.form.model.setNotPassed = true;
            this.form.save().then((progress) => {
                this.progress = progress;
                this.mappedFsAnswers = this.getMappedFsAnswers(this.progress.formSubmission.formSubmissionAnswers);
            });
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/validations/detail/index.js